<template>
  <table class="key-value-table uk-table uk-table-divider uk-table-justify">
    <tbody>
      <tr v-for="entry in entries">
        <td
          class="key-value-table__key uk-table-shrink uk-text-right uk-text-bold"
          :title="entry[namesFrom]"
        >
          {{entry[namesFrom]}}
        </td>
        <td class="key-value-table__value">
          <slot name="value" :name="entry[namesFrom]" :value="entry[valuesFrom]">
            <span v-if="entry[valuesFrom]">{{entry[valuesFrom]}}</span>
            <text-placeholder v-else />
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'key-value-table',
  components: {
    TextPlaceholder,
  },
  props: {
    entries: {
      type: Array,
      required: true,
    },
    namesFrom: {
      type: String,
      default: 'name',
    },
    valuesFrom: {
      type: String,
      default: 'value',
    },
  },
};
</script>

<style lang="scss">
.key-value-table__key {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 150px;
}
</style>



// WEBPACK FOOTER //
// KeyValueTable.vue?0d30328e